/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Users_Settings_Recording_Show_Stop_ButtonInputs */

const en_forms_users_settings_recording_show_stop_button = /** @type {(inputs: Forms_Users_Settings_Recording_Show_Stop_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Button`)
};

const de_forms_users_settings_recording_show_stop_button = /** @type {(inputs: Forms_Users_Settings_Recording_Show_Stop_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stopp-Button anzeigen`)
};

/**
* | output |
* | --- |
* | "Button" |
*
* @param {Forms_Users_Settings_Recording_Show_Stop_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_users_settings_recording_show_stop_button = /** @type {((inputs?: Forms_Users_Settings_Recording_Show_Stop_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Users_Settings_Recording_Show_Stop_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_users_settings_recording_show_stop_button(inputs)
	return de_forms_users_settings_recording_show_stop_button(inputs)
});